import { useEffect } from "react";

import UserProfile from "./UserProfile/UserProfile";
// import { useTour } from "@reactour/tour";
import { Breadcrumbs } from "../../../AbstractElements";
import { Col, Container, Row } from "reactstrap";
import MembersList from "./UserProfile/MembersList";
import ConcernForm from "./UserProfile/ConcernForm";
import InquiryStatus from "./UserProfile/InquiryStatus";

const TourMain = () => {
//   const { setIsOpen } = useTour();
//   useEffect(() => {
//     var timer = setTimeout(() => {
//       setIsOpen(true);
//     }, 100);
//     return () => {
//       clearTimeout(timer);
//     };
//   }, []);
  return (
    <>
      <Breadcrumbs mainTitle="UserProfile" parent="user" title="userprofile" />

      <Container fluid={true}>
        <div className="user-profile">
          <Row>
            <UserProfile />
          </Row>
          <Row>
            <Col>
            <MembersList/>
            </Col>
            <Col></Col>
            {/* <Col>
            <InquiryStatus/>
            </Col> */}
          </Row>
          <Row>
          {/* <Col>
            <ConcernForm/>
            </Col> */}
            <Col>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default TourMain;
